var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chekcbox",class:{checked:_vm.checked},on:{"click":_vm.clickHandle}},[(_vm.checked)?_c('gouImg',_vm._b({},'gouImg',{color: '#fff',width:'12px',height:'12px'},false)):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }